import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { LOGO_URL, SUPPORT_EMAIL } from "../../lib/site";
import StoreButtons from "./StoreButtons";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-ink text-white">
      <div className="mesh-glow pointer-events-none absolute inset-0 opacity-40" />
      <div className="relative mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5">
              <img src={LOGO_URL} alt="RenewTracker" className="h-10 w-10 rounded-xl bg-white" />
              <span className="font-display text-xl font-bold tracking-tight">
                Renew<span className="text-brand-light">Tracker</span>
              </span>
            </Link>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              Smart renewal &amp; compliance management for businesses and individuals. Track every deadline in one secure place and never miss an important renewal again.
            </p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid="footer-email"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm text-white/80 transition-colors duration-200 hover:border-greenaccent hover:text-white"
            >
              <Mail className="h-4 w-4 text-greenaccent" /> {SUPPORT_EMAIL}
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-white/40">Company</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" className="text-white/70 transition-colors hover:text-white" data-testid="footer-home">Home</Link></li>
              <li><Link to="/contact" className="text-white/70 transition-colors hover:text-white" data-testid="footer-contact">Contact</Link></li>
              <li><Link to="/privacy" className="text-white/70 transition-colors hover:text-white" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-white/70 transition-colors hover:text-white" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/delete-account" className="text-white/70 transition-colors hover:text-white" data-testid="footer-delete-account">Account Deletion</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-white/40">Get the app</h4>
            <p className="mt-4 text-sm text-white/60">Launching soon on mobile.</p>
            <StoreButtons className="mt-4" />
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-sm text-white/50">Copyright © {year} RenewTracker. All rights reserved.</p>
          <div className="flex items-center gap-5 text-sm text-white/50">
            <Link to="/privacy" className="transition-colors hover:text-white">Privacy</Link>
            <Link to="/terms" className="transition-colors hover:text-white">Terms</Link>
            <a href="https://renewtracker.site" className="inline-flex items-center gap-1 transition-colors hover:text-white">
              renewtracker.site <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
